import classes from '../styles/Page.module.scss';

/**
 * Simfy Web Home Page
 *
 * @returns {JSX.Element}
 * @constructor
 */
const Legal = () => {
    return (
        <div className={classes.oPageHome}>
            <div className={classes.oContent}>
                <h1 className={`${classes.aPageTitle} fntH1`}>SIMFY AFRICA PRIVACY POLICY</h1>
                <ol className={classes.mContent}>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>INTRODUCTION</h3>
                        <ol>
                            <li>
                                This Privacy Policy, together with our Terms and Conditions sets out
                                the basis on which any Personal Information (as defined in paragraph
                                2.2 below) that we collect from you, or that you provide to us, will
                                be used, stored and processed by us.
                            </li>
                            <li>
                                We, Simfy Africa Proprietary Limited, a private company incorporated
                                in accordance with the laws of South Africa, with the registration
                                number 2011/129834/07, with our office&quot;s address at Ground
                                Floor, Darter Studio, Longkloof, 4 Darters Road, Gardens, Cape Town,
                                (&quot;Simfy &quot;) are the &quot;responsible party&quot; for
                                purposes of applicable data protection legislation in respect of all
                                Personal Information you submit to us via the website, other related
                                URLs, and/or any ancillary services (&quot; Website&quot;) and/or in
                                any correspondence and/or communication with us. Please see
                                paragraph 7 below as it deals with Personal Information you submit
                                to third-parties.
                            </li>
                            <li>
                                We are a digital services company, that distributes digital content,
                                music and games from content partners and services developers, in
                                addition to enabling messaging functionality, making such content,
                                music, games and messaging functionality available to users of the
                                Ayoba application, a super-app owned and operated by our affiliate
                                Progressive tech Holdings.
                            </li>
                            <li>
                                We recognize the importance of protecting your privacy in respect of
                                Personal Information collected by us when you use the Website.
                            </li>
                        </ol>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>
                            INFORMATION WE MAY COLLECT FROM YOU
                        </h3>
                        <ol>
                            <li>
                                When you use the Website, we may collect certain information that is
                                not Personal Information such as your operating system, browser
                                type, and Internet service provider (see paragraph 6.1 below for
                                further details). This type of information does not identify you
                                personally.
                            </li>
                            <li>
                                When you access our Website, we may also collect Personal
                                Information that you provide to us. For purposes of this Privacy
                                Policy &quot;Personal Information&quot; shall mean any information
                                of a personal nature by which you can be identified as an individual
                                such as your name, postal address, email address, telephone number,
                                home country, postal code, your fax number, gender, age, financial
                                details, and/or company name, business information and VAT number.
                            </li>
                            <li>
                                We also may collect information including Personal Information in
                                other ways including through carrying out demographic research.
                            </li>
                            <li>
                                We may collect, process and store the following information (which
                                may include Personal Information) about you –
                                <ol>
                                    <li>
                                        information that you provide by filling in forms on the
                                        Website;
                                    </li>
                                    <li>
                                        information about your device software and hardware,
                                        including the unique internet mobile equipment identity
                                        (&quot; IMEI&quot;), number of your mobile telephone, the
                                        unique integrated circuit card identity (&quot; ICCID&quot;)
                                        number of your SIM cards in your device, your email address,
                                        personal internet protocol (&quot; IP&quot;) address, mobile
                                        phone number;
                                    </li>
                                    <li>
                                        your geographic location information based on your mobile
                                        network operator`&apos;s tower details, GPS (Global
                                        Positioning System) and/or WIFI communications network
                                        location;
                                    </li>
                                    <li>
                                        the date and time, country and the IP address of the device
                                        from which you connect to our Website;
                                    </li>
                                    <li>
                                        information that we may ask you for if you report a problem
                                        with our Website;
                                    </li>
                                    <li>
                                        details of your visits to our Website (including, but not
                                        limited to, traffic data, location data, weblogs and other
                                        communication data and the resources that you access; and
                                    </li>
                                    <li>
                                        if you contact us, we may keep a record of that
                                        correspondence;
                                    </li>
                                </ol>
                            </li>
                            <li>
                                We may also ask you to complete surveys that we use for research and
                                forecasting purposes, although you do not have to respond to them.
                            </li>
                            <li>
                                We may also collect information (which may include Personal
                                Information) that our users provide, such as new or deleted comments
                                and keyword searches.
                            </li>
                            <li>
                                The supply of your Personal Information is voluntary; however, you
                                acknowledge that we cannot make certain services available to you on
                                the Website if you do not wish to supply such Personal Information.
                            </li>
                            <li>
                                We may use a third-party company to monitor website traffic, which
                                may, in some instances, store your information, including the
                                Personal Information you submit to such third parties.
                            </li>
                            <li>
                                By continuing to use the Website, you consent to processing,
                                collection, storage, retention and use of the Personal Information
                                you provide for the purposes set out in this Privacy Policy, and you
                                consent to our collection of any changes or updates that you may
                                provide to any information you provide that is collected by us. If
                                you do not agree to the Privacy Policy, please do not use the
                                Website.
                            </li>
                            <li>
                                2.10.Where you provide us with Personal Information relating to a
                                third-party data subject (for example, your customers and/or
                                clients), you warrant that you have obtained all necessary consents
                                from such data subject, including the data subject`&apos;s consent
                                for you to share such Personal Information with Simfy to process. We
                                shall protect, store and process this Personal Information in the
                                same manner and equal level of security as Personal Information
                                about you.
                            </li>
                        </ol>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>
                            HOW YOUR INFORMATION IS USED AND DISCLOSED
                        </h3>
                        <ol>
                            <li>
                                We may use the information, including the Personal Information we
                                hold about you for the following purposes –
                                <ol>
                                    <li>to verify and keep a record of your identity;</li>
                                    <li>
                                        to ensure that content from our Website is presented in the
                                        most effective manner for you and for your computer and/or
                                        mobile device;
                                    </li>
                                    <li>
                                        to monitor and analyse the conduct on the Website to ensure
                                        compliance with laws, reduce the likelihood of fraud and
                                        other risk-prevention purposes;
                                    </li>
                                    <li>
                                        in aggregate form, for internal business purposes such as
                                        generating statistics and developing our strategic and
                                        marketing plans;
                                    </li>
                                    <li>
                                        to provide you with information on our Website that you
                                        request from us where you have consented to be contacted for
                                        such purposes;
                                    </li>
                                    <li>
                                        to carry out statistical and marketing research to identify
                                        potential markets and trends;
                                    </li>
                                    <li>
                                        to allow you to participate in interactive features on our
                                        Website, when you choose to do so;
                                    </li>
                                    <li>to carry out any contracts that may form between us;</li>
                                    <li>to respond to any queries, you make; and</li>
                                </ol>
                            </li>
                            <li>
                                We may use information provided by you to –
                                <ol>
                                    <li>
                                        enforce agreements and terms and conditions between us,
                                        monitor user activity, such as keyword searches or new
                                        postings, and more effectively manage traffic on the
                                        Website;
                                    </li>
                                    <li>provide customer services, and</li>
                                    <li>assist you with technical difficulties.</li>
                                </ol>
                            </li>
                            <li>
                                We will not use your Personal Information for any purpose (other
                                than as stated above) without your express consent. Except for in
                                terms of the other provisions of this Privacy Policy, we will not
                                use or disclose your Personal Information to third parties without
                                your consent, unless the use or disclosure is –
                                <ol>
                                    <li>
                                        required to comply with applicable law, order of court or
                                        legal process served on Simfy ; and/or
                                    </li>
                                    <li>
                                        disclosure is necessary to protect and defend the rights or
                                        property of Simfy .
                                    </li>
                                </ol>
                            </li>
                            <li>
                                We will be entitled to disclose your Personal Information to our
                                affiliates, agents, advisors, employees and/or third-party service
                                providers and suppliers (including payment providers) who assist us
                                to interact with you via our Website, mobile communications and/or
                                email, and thus need to know your Personal Information in order to
                                assist us and to communicate with you properly and efficiently. We
                                will ensure that all such employees and/or third-party service
                                providers having access to your personal information are bound by
                                appropriate and legally binding confidentiality and non-use
                                obligations in relation to your Personal Information.
                            </li>
                            <li>
                                Your information may be shared with organizations within our
                                company`&apos;s group located in other countries around the world.
                                We will only transfer data overseas where we are satisfied that
                                adequate levels of protection are in place to protect any
                                information held in that country or that the service provider acts
                                at all times in compliance with applicable privacy laws. Where
                                required under applicable laws we will take measures to ensure that
                                Personal Information handled in other countries will receive at
                                least the same level of protection as it is given in this Privacy
                                Policy.
                            </li>
                            <li>
                                On rare occasions, we may be required to disclose your Personal
                                Information due to legal or regulatory requirements. In such
                                instances, we reserve the right to disclose your Personal
                                Information as required to comply with our legal obligations,
                                including but not limited to complying with court orders, warrants,
                                subpoenas, service of process requirements or discovery requests.
                            </li>
                            <li>
                                We may also disclose information about our users to law enforcement
                                officers or others, in the good faith belief that such disclosure is
                                reasonably necessary to enforce this Privacy Policy, respond to
                                claims that any content violates the rights of third parties; or
                                protect our legitimate interest and/or the rights, property, or our
                                personal safety or the personal safety of our users or the general
                                public.
                            </li>
                        </ol>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>
                            PROTECTION OF YOUR PERSONAL INFORMATION
                        </h3>
                        <ol>
                            <li>
                                We recognize that protecting your privacy is important to you. For
                                this reason, we are committed to protecting the Personal Information
                                you provide in a variety of ways.
                            </li>
                            <li>
                                We will –
                                <ol>
                                    <li>
                                        treat your Personal Information as strictly confidential;
                                    </li>
                                    <li>
                                        take appropriate technical and organizational measures to
                                        ensure that your Personal Information is kept secure and is
                                        protected against unauthorized or unlawful processing,
                                        accidental loss, destruction or damage, alteration,
                                        disclosure or access;
                                    </li>
                                    <li>
                                        promptly notify you if we become aware of any unauthorized
                                        use, disclosure or processing of your personal information;
                                    </li>
                                    <li>
                                        provide you with reasonable evidence of our compliance with
                                        our obligations under this Privacy Policy on reasonable
                                        notice and request; and
                                    </li>
                                    <li>
                                        upon your request, promptly return or destroy any and all of
                                        your Personal Information in our possession or control.
                                    </li>
                                </ol>
                            </li>
                            <li>
                                We will not retain your Personal Information longer than the period
                                for which it was originally needed, unless we are required by law to
                                do so, or you consent to us retaining such information for a longer
                                period.
                            </li>
                        </ol>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>
                            STORAGE AND SECURITY OF YOUR PERSONAL INFORMATION
                        </h3>
                        <ol>
                            <li>
                                We will do our best to protect your Personal Information, and we
                                will use technology that will help us to do this, however, the
                                transmission of information via the Internet is not completely
                                secure and we cannot guarantee the security of your information
                                transmitted to our Website. Any transmission of your information to
                                our Website is entirely at your own risk. Once we have received your
                                information, we will use strict procedures and security features to
                                try to prevent unauthorised access.
                            </li>
                            <li>
                                We may, from time to time, transfer, store or host your Personal
                                Information on servers outside of South Africa. We will at all times
                                ensure that appropriate security safeguards are in place to secure
                                and protect such personal information held in another country or
                                that the service provider acts at all times in compliance with
                                applicable privacy laws. Where required under applicable laws we
                                will take measures to ensure that Personal Information handled in
                                other countries will receive at least the same level of protection
                                as it is given in this Privacy Policy.
                            </li>
                        </ol>
                        <br />
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>
                            YOUR RIGHTS IN RESPECT OF YOUR PERSONAL INFORMATION
                        </h3>
                        <br />
                        Your Rights in respect of your Personal Information
                        <br />
                        In terms of Data Privacy Laws you have certain rights including:
                        <br />
                        <br />
                        <ol>
                            <li>
                                Access rights: You have the right to access your Personal
                                Information in many circumstances. This enables you to receive a
                                copy of the Personal Information we hold about you and to check that
                                we are lawfully processing it.
                            </li>
                            <li>
                                Right to rectification : You can require us to have inaccurate
                                Personal Information corrected.
                            </li>
                            <li>
                                Right to object : You have the right to object to the processing of
                                your Personal Information at any time, on reasonable grounds
                                relating to your particular situation, unless the processing is
                                required by law.
                            </li>
                            <li>
                                Right to erasure: You can require us to erase Personal Information
                                in certain circumstances where there is no lawful basis for us to
                                retain such Personal Information. Please note, however, that in some
                                instances we must retain your Personal Information for certain
                                periods of time as required by law.
                            </li>
                            <li>
                                Right to restrict: You can require us to restrict our processing of
                                your Personal Information in certain circumstances.
                            </li>
                            <li>
                                Right to withdraw consent: You can withdraw any consents to
                                processing that you have given us and prevent further processing if
                                there is no other legitimate ground upon which we can process your
                                Personal Information.
                            </li>
                            <li>
                                Right to complain: You can raise a complaint about our processing
                                with the South African Information Regulator, or with our
                                Information Officer. Information Regulator:
                                <a href="http://www.justice.gov.za/inforeg/contact.html">
                                    www.justice.gov.za/inforeg/contact.html
                                </a>
                                or
                                <a href="https://owa.justice.gov.za/owa/redir.aspx?C=Vk7vfuiglJIRD2HwpsUfa_fY0BgFmszRLMKYQyM258la4yFS_0fYCA..&amp;URL=mailto:complaints.IR@justice.gov.za">
                                    complaints.IR@justice.gov.za
                                </a>
                                <br />
                                <br />
                                You also have a duty to inform us of changes to your Personal
                                Information: It is important that the Personal Information we hold
                                about you is accurate and current. Please keep us informed if your
                                Personal Information changes during your working relationship with
                                us.
                                <br />
                                <br />
                            </li>
                        </ol>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>
                            COOKIES AND OTHER INFORMATION
                        </h3>
                        <p>
                            We may collect information about your computer, including where
                            available, your operating system, browser type, third-party software
                            installed on your device, installation and uninstallation rates, the
                            language of your device and computers manufacturer, screen size and
                            model of the device and any other technical information for system
                            administration and to report aggregate information to our advertisers.
                        </p>
                        <p>
                            This is statistical data about our users&apos; browsing actions and
                            patterns and does not identify any individual.
                        </p>
                        <p>
                            We may use cookies to manage our users&apos; sessions and to store
                            preferences, tracking information, and language selection. “ Cookies”
                            are small text files transferred by a web server to your hard drive and
                            thereafter stored on your computer. The types of information a Cookie
                            collects include the date and time you visited the Website, your
                            browsing history, your preferences, and your username.
                        </p>
                        <p>
                            In some instances, our third-party service providers may use Cookies on
                            the Website. We cannot control, or access Cookies used by third-party
                            service providers. This Privacy Policy covers only Cookies used by us,
                            and not any Cookies used by third parties.
                        </p>
                        <p>Cookies enable us to –</p>
                        <ol>
                            <li>estimate our Website`&apos;s audience size and usage pattern;</li>
                            <li>
                                store information about your preferences, which allows us to
                                customize the Website according to your individual interests;
                            </li>
                            <li>speed up your searches; and</li>
                            <li>
                                recognize you when you return to the Website.
                                <br />
                                <br />
                                You have the ability to either accept or decline the use of Cookies
                                on your computer, whether you are registered with us or not.
                                Typically, you can configure your browser to not accept Cookies.
                                However, declining the use of Cookies may limit your access to
                                certain features of the Website. For example, you may have
                                difficulty using certain interactive features of the Website.
                            </li>
                        </ol>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>THIRD PARTIES</h3>
                        <ol>
                            <li>
                                We may use third-party service providers to monitor our users’
                                interests. In addition, the Website may occasionally contain links
                                to third-party websites. If you click on the links to third-party
                                websites, you leave the Website.
                            </li>
                            <li>
                                We are not responsible for the content of these third-party websites
                                or for the security of your Personal Information when you use the
                                third-party websites. These third-party service providers and
                                third-party websites may have their own privacy policies governing
                                the storage and retention of your Personal Information that you may
                                be subject to. They may also collect information that is not
                                Personal Information such as your browser specification, or
                                operating system.
                            </li>
                            <li>
                                This Privacy Policy does not govern Personal Information provided
                                to, stored on, or used by these third-party providers and
                                third-party websites. We recommend that when you enter a third
                                party`&apos;s website, you review its privacy policy as it relates
                                to how such third parties collect, process, store and protect your
                                Personal Information.
                            </li>
                            <li>
                                <p>You agree that we are not liable for any of the following –</p>
                                <ol>
                                    <li>
                                        the content, security, operation, use, accuracy or
                                        completeness of any such third-party websites; or the
                                        products or services that may be offered or obtained through
                                        them; or the accuracy, completeness, or reliability of any
                                        information obtained from a third-party website;
                                    </li>
                                    <li>
                                        the ownership or right of use of any licensor of any
                                        software provided through any third-party website;
                                    </li>
                                    <li>
                                        any content featured on third-party website that are
                                        accessed through the links found on the Website;
                                    </li>
                                    <li>
                                        any failure or problem that affects the products or services
                                        of a third-party website, for example any telecommunication
                                        service provider, internet service provider, electricity
                                        supplier, local or other authority.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>GENERAL</h3>
                        <ol>
                            <li>
                                You warrant that all information (including Personal Information)
                                that you provide to us is accurate, truthful and current
                                information, and not to impersonate or misrepresent any person or
                                entity or falsely state or otherwise misrepresent your affiliation
                                with anyone or anything. Failure to adhere to this requirement will
                                entitle Simfy inter alia, to terminate your use of the Website.
                            </li>
                            <li>
                                You acknowledge that we may verify your identity and your Personal
                                Information through an automated email verification process and/or
                                with third party service providers.
                            </li>
                            <li>
                                You may request access to the Personal Information which we collect
                                from you, including to rectify the information, or object to its
                                processing by sending an email to us at &nbsp;
                                <a href="mailto:legal@simfy.africa">legal@simfy.africa</a>. You also
                                have the right to lodge a complaint with the information regulator
                                if you think we are in breach of any applicable data protection
                                legislation.
                            </li>
                            <li>
                                You may access, remove, review, and/or make changes to Personal
                                Information that you have provided to us. We may also send you any
                                legally required notifications and other notifications, including
                                but not limited to, service related notices or notices regarding a
                                change to any of our policies. For example, we may send you a notice
                                regarding server problems or scheduled maintenance to the Website.
                            </li>
                            <li>
                                If this Privacy Policy or any provision in this Privacy Policy is
                                regulated by or subject to the Protection of Personal Information
                                Act 4 of 2013 (&quot;POPI&quot;) or other data protection
                                legislation, it is not intended that any provision of this Privacy
                                Policy contravenes any provision of POPI or other data protection
                                legislation. Therefore, all provisions of this Privacy Policy must
                                be treated as being qualified, to the extent necessary, to ensure
                                that the provisions of POPI or other data protection legislation are
                                complied with.
                                <br />
                                <br />
                            </li>
                        </ol>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>NOTIFICATION OF CHANGES</h3>
                        We reserve the right to change this Privacy Policy from time to time, and in
                        our sole discretion. We may send you a notice regarding material changes to
                        this Privacy Policy, but we encourage you to frequently check this Privacy
                        Policy for any changes. Your continued use of the Website after any change
                        in this Privacy Policy will constitute your acceptance of such changes.
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>CHILDREN</h3>
                        The site is not intended for children and we do not knowingly or intend to
                        collect Personal Information of children. If you are under the age do not
                        use our Website without the consent of your legal guardian.
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>HOW TO CONTACT US</h3>
                        If you have questions about this Privacy Policy, please contact us at &nbsp;
                        <a href="mailto:legal@simfy.africa">legal@simfy.africa</a> with “Privacy
                        Policy” in the subject line.
                    </li>
                </ol>
            </div>
        </div>
    );
};

export default Legal;
